function Background() {

    return (

        <img className = "website-background" src="/codeimgbg.png" alt="background" /> 
        
    )
}

export default Background;